export const TEXT = {
  NOTIFICATION_SUCCESS: { id: 'payment.notification.payment_method_selected_to_delayed_tokenization' },
};
